import { render, staticRenderFns } from "./LocationDashboardToDo.vue?vue&type=template&id=162c96ff&scoped=true&"
import script from "./LocationDashboardToDo.vue?vue&type=script&lang=ts&"
export * from "./LocationDashboardToDo.vue?vue&type=script&lang=ts&"
import style0 from "./LocationDashboardToDo.vue?vue&type=style&index=0&id=162c96ff&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c96ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VContainer,VIcon,VList,VListItem,VListItemTitle,VTooltip})
